import { api } from '../client';
import type { InvoiceResponse } from '../types';
export type InvoicePdfVariant = 'ORIGINAL' | 'CANCELLED';
export interface InvoicePdfLink {
  status: 'READY' | 'NOT_READY';
  invoiceId: number;
  invoiceNumber: string;
  builtForStatus: 'ISSUED' | 'CANCELLED';
  downloadUrl: string | null;
  expiresAt: string | null;
}
export interface MissingInvoicePdfs {
  items: Array<{ invoice: InvoiceResponse; copies: InvoicePdfVariant[] }>;
  nextAfterId: number | null;
}
export async function getInvoicePdf(id: number, variant: InvoicePdfVariant) {
  const { data } = await api.get<InvoicePdfLink>(`/invoices/${id}/pdf`, { params: { variant } });
  return data;
}
export async function getMissingInvoicePdfs(afterId = 0) {
  const { data } = await api.get<MissingInvoicePdfs>('/admin/invoices/pdf-missing', {
    params: { afterId, size: 50 },
  });
  return data;
}
export async function attachInvoicePdf(
  invoice: InvoiceResponse,
  variant: InvoicePdfVariant,
  upload: { intentId: string; sha256: string },
  signal?: AbortSignal,
) {
  await api.post(
    `/admin/invoices/${invoice.id}/pdf`,
    {
      uploadIntentId: upload.intentId,
      variant,
      invoiceNumber: invoice.invoiceNumber,
      builtForStatus: variant === 'ORIGINAL' ? 'ISSUED' : 'CANCELLED',
      sha256: upload.sha256,
    },
    ...(signal ? [{ signal }] : []),
  );
}
